export const DEFAULT_RWD_SELECTORS = Object.freeze({
  basketStage: 'body.shop_basket',
  purchaseChoiceStage: 'body.shop_basket_step2, input[name="loginform"]',
  addressStage: 'body.shop_basket_address, input[name="addressform"]',
  summaryStage: 'body.shop_basket_step3, input[name="summaryform"]',
  completeStage: 'body.shop_basket_done',
  shippingList: '#box_basketlist',
  shippingRow: '.delivery',
  shippingControl: 'input[name="shipping_id"]',
  shippingIdAttribute: 'value',
  shippingButtonAnchor: '.description',
  basketCountry: 'select[name="shipping_country"]',
  addressCountry: '#input_country[name="country"]',
  deliveryCountry: '#input_country2[name="country2"]',
  differentAddress: '#address_different[name="different"]',
  differentAddressContent: '.different_address, .client-address-different > .different, .client-address-different > .address-different',
  paymentControl: 'input[name="payment_id"]',
  codInput: '#is_cod[name="is_cod"]',
  basketForm: 'form:has(input[name="shipping_id"])',
  addressForm: 'form:has(input[name="addressform"])',
  summaryForm: 'form:has(input[name="summaryform"])',
  addressAnchor: 'form:has(input[name="addressform"]) .client-address-different',
  summaryAnchor: 'form:has(input[name="summaryform"])',
  forwardButton: 'button[name="button2"]',
  backButton: 'button[name="button1"], .js__no-validate',
  pickupField: 'input[name="additional_{fieldId}"]',
})

export function createRwdSelectors(overrides = {}, root = document) {
  if (!overrides || typeof overrides !== 'object' || Array.isArray(overrides)) {
    throw new Error('Konfiguracja selektorów RWD musi być obiektem.')
  }

  const selectors = { ...DEFAULT_RWD_SELECTORS }
  for (const [key, value] of Object.entries(overrides)) {
    if (!Object.hasOwn(DEFAULT_RWD_SELECTORS, key)) {
      throw new Error(`Nieznana opcja konfiguracji RWD: ${key}.`)
    }
    if (typeof value !== 'string' || !value.trim()) {
      throw new Error(`Nieprawidłowa wartość konfiguracji RWD: ${key}.`)
    }
    selectors[key] = value.trim()
  }

  for (const [key, value] of Object.entries(selectors)) {
    if (key === 'shippingIdAttribute') {
      if (!/^[a-zA-Z_][\w:.-]*$/.test(value)) {
        throw new Error('Nieprawidłowy atrybut identyfikatora dostawy RWD.')
      }
      continue
    }
    if (key === 'pickupField' && !value.includes('{fieldId}')) {
      throw new Error('Selektor pola punktu RWD wymaga znacznika {fieldId}.')
    }
    try {
      root.querySelector(value.replaceAll('{fieldId}', '1'))
    } catch {
      throw new Error(`Nieprawidłowy selektor RWD: ${key}.`)
    }
  }
  return Object.freeze(selectors)
}

export function getCustomRwdSelectorKeys(overrides = {}) {
  if (!overrides || typeof overrides !== 'object' || Array.isArray(overrides)) {
    return new Set()
  }

  return new Set(Object.keys(overrides).filter(key => Object.hasOwn(DEFAULT_RWD_SELECTORS, key)))
}

export function getRwdPickupFieldSelector(selectors, fieldId) {
  const id = String(fieldId ?? '')
  if (!/^[1-9]\d*$/.test(id)) {
    throw new Error('Brak prawidłowego identyfikatora pola punktu RWD.')
  }
  return selectors.pickupField.replaceAll('{fieldId}', id)
}

export function detectRwdStage(root = document, selectors = DEFAULT_RWD_SELECTORS) {
  // Adres z błędami jest zwracany pod /step2, podobnie jak ekran logowania.
  for (const [stage, key] of [
    ['summary', 'summaryStage'],
    ['address', 'addressStage'],
    ['complete', 'completeStage'],
    ['purchase-choice', 'purchaseChoiceStage'],
    ['basket', 'basketStage'],
  ]) {
    if (root.querySelector(selectors[key])) return stage
  }
  return 'other'
}
